var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectedBusiness(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.50015 19.7077V16.041M2.2915 19.7077H19.7082M5.95817 7.44727V4.12435C5.95817 3.63812 6.15133 3.1718 6.49514 2.82799C6.83896 2.48417 7.30527 2.29102 7.7915 2.29102H16.0415V11.4004M12.3748 19.7077V13.291C12.3748 12.8048 12.568 12.3385 12.9118 11.9947C13.2556 11.6508 13.7219 11.4577 14.2082 11.4577H18.7915V19.7077M3.20817 19.7077V9.62435C3.20817 9.13812 3.40132 8.6718 3.74514 8.32799C4.08896 7.98417 4.55527 7.79102 5.0415 7.79102H9.62484V19.7077H3.20817Z",
    stroke: "#007C92",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedBusiness);
export default __webpack_public_path__ + "static/media/SelectedBusiness.b9c65b9dad9b1adf4cf7c7389b5fe93d.svg";
export { ForwardRef as ReactComponent };